import React, { useEffect, useState } from 'react';
import { CgSpinner } from 'react-icons/cg';
import { BookingQuestionsModal } from '../common/modals';
import './bookingstsCancelModal.css';

/**
 * Confirmation modal used before cancelling a BOOKINGSTS booking.
 * Submit remains disabled until the user explicitly confirms cancellation.
 */
export default function BookingstsCancelModal({
    modalActive,
    setModalActive,
    roomName,
    date,
    startTime,
    endTime,
    bookedByDisplayName,
    onSubmit,
}) {
    const [confirmed, setConfirmed] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [notifyAttendees, setNotifyAttendees] = useState(false);
    const [notifyReason, setNotifyReason] = useState('');

    useEffect(() => {
        if (!modalActive) {
            setConfirmed(false);
            setSubmitting(false);
            setNotifyAttendees(false);
            setNotifyReason('');
        }
    }, [modalActive]);

    async function handleSubmit() {
        if (!confirmed) {
            return;
        }

        setSubmitting(true);
        try {
            await onSubmit({
                notifyAttendees,
                notifyReason: String(notifyReason || '').trim(),
            });
            setModalActive(false);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <BookingQuestionsModal modalActiveState={modalActive} setStateFunction={setModalActive}>
            <div className='bookingstsCancelContainer'>
                <div className='bookingstsCancelDetails'>
                    <p>{roomName}</p>
                    <p>{date} {startTime} - {endTime}</p>
                    <p>{bookedByDisplayName}</p>
                </div>

                <label className='bookingstsCancelNotifyRow' htmlFor='bookingstsCancelNotifyAttendees'>
                    <span>Notify attendees via email</span>
                    <span className='bookingstsCancelSwitch'>
                        <input
                            id='bookingstsCancelNotifyAttendees'
                            type='checkbox'
                            checked={notifyAttendees}
                            onChange={(event) => {
                                const nextChecked = Boolean(event.target.checked);
                                setNotifyAttendees(nextChecked);
                                if (!nextChecked) {
                                    setNotifyReason('');
                                }
                            }}
                        />
                        <span className='bookingstsCancelSlider' />
                    </span>
                </label>
                <p className='bookingstsCancelNotifyHelp'>
                    If another authorised user cancels this booking, the organiser will still be emailed. This switch only controls attendee emails.
                </p>

                {notifyAttendees && (
                    <div className='bookingstsCancelReasonWrap'>
                        <input
                            className='bookingstsCancelReasonInput'
                            type='text'
                            value={notifyReason}
                            onChange={(event) => setNotifyReason(event.target.value)}
                            placeholder='Enter reason for cancellation email'
                            maxLength={200}
                        />
                    </div>
                )}

                <label className='bookingstsCancelConfirmRow' htmlFor='bookingstsCancelConfirm'>
                    <input
                        className='bookingstsCancelConfirmInput'
                        id='bookingstsCancelConfirm'
                        type='checkbox'
                        checked={confirmed}
                        onChange={(event) => setConfirmed(Boolean(event.target.checked))}
                    />
                    <span>Confirm cancellation booking</span>
                </label>

                <div className='bookingstsCancelSubmitArea'>
                    <button
                        className={`formSubmitButton bookingstsCancelSubmitButton ${(!confirmed || submitting) ? 'bookingstsCancelSubmitButtonDisabled' : ''}`}
                        type='button'
                        onClick={handleSubmit}
                        disabled={!confirmed || submitting}
                    >
                        {submitting ? <CgSpinner className='submit-button-spinner' /> : 'Cancel meeting'}
                    </button>
                </div>
            </div>
        </BookingQuestionsModal>
    );
}
